import { EquipmentOperationalStatus } from '@operations/app/api'
import { TFnType } from '@tolgee/react'
import { tomTableColumnFilterPresets } from '@tom-ui/ui'
import { MRT_ColumnDef, MRT_RowData } from 'material-react-table'

export const operationalEquipmentFilterPresets = {
  ...tomTableColumnFilterPresets,

  statusSelect: <T extends MRT_RowData>(t: TFnType): Partial<MRT_ColumnDef<T, unknown>> => ({
    filterVariant: 'select',
    filterSelectOptions: Object.values(EquipmentOperationalStatus).map(status => ({
      label: t(status.toLowerCase()),
      value: status,
    })),
    filterFn: 'equals',
    enableColumnFilterModes: false,
  }),
}
